import React, { Fragment, useEffect } from 'react';
import NewNavbar from '../../new-components/NewNavbar';
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from '../../new-components/NewOverrides';
import NewDesignSystem from '../../new-components/NewDesignSystem';
import NewFooter from '../../new-components/NewFooter';
import NewMadeWith from '../../new-components/NewMadeWith';
import NewScrollTop from '../../new-components/NewScrollTop';
import ProjectSection from '../../components/ProjectSection';

const PortfolioMasonaryPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />

      <NewPageHeader />
      <ProjectSection prClass={'pt-120'} />
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};
export default PortfolioMasonaryPage;
